import { enrichCart } from './cart.enricher';
import { enrichPriceSummmary } from './price-summary.enricher';
export const CartEnrichers = {
  enrichCart,
  enrichPriceSummmary
};
//# sourceMappingURL=index.js.map